<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  export default defineComponent({
    name: 'ApiError',
    props: {
      error: {
        type: Object as PropType<Error | { message: string } | null>,
        default: () => ({}),
      },
      withCrossButton: {
        type: Boolean,
        default: true,
      },
      id: {
        type: String,
        default: '',
      },
      ariaLive: {
        type: String,
        default: 'assertive',
        validator: (value: string) => ['polite', 'assertive', 'off'].includes(value),
      },
    },
    emits: ['close'],
    computed: {
      isErrorMessageVisible() {
        if (!this.error) return false
        console.log(this.error, 'API ERRROR')
        // Accept Error instances
        if (this.error instanceof Error) return true

        // Accept error-like objects (CommonError, BaseError, etc.) with message property
        // but exclude empty objects
        return (
          typeof this.error === 'object' &&
          'message' in this.error &&
          typeof this.error.message === 'string' &&
          this.error.message.length > 0
        )
      },
      errorId() {
        return this.id || `error-${Math.random().toString(36).substr(2, 9)}`
      },
    },
  })
</script>
<template>
  <BaseNotification
    v-if="isErrorMessageVisible"
    :id="errorId"
    with-emit
    type="error"
    :with-cross-button="withCrossButton"
    role="alert"
    :aria-live="ariaLive"
    aria-atomic="true"
    data-test-id="error"
    @close="$emit('close')"
  >
    <div class="d-flex align-center">
      <BaseIcon
        class="mr-5"
        icon-name="icon-error.svg"
        icon-color="red"
        width="16px"
        height="16px"
        is-without-hover="true"
        role="img"
        aria-label="Error icon"
      />
      <span class="error-message">{{ error?.message }}</span>
    </div>
  </BaseNotification>
</template>
